export default __webpack_public_path__ + "static/media/twitter.8c1638b6.svg";